import { useMutation, useQueryClient } from '@tanstack/react-query'

import { CreateCompanyChallengeDto, GetCompanyChallengesQueryKey } from '@src/type/challenge'
import { createCompanyChallenge } from '@src/lib/api/challenge'

export type ParamType = {
	invalidateQueryKey?: GetCompanyChallengesQueryKey
}

export function useCreateCompanyChallengeMutate({ invalidateQueryKey }: ParamType) {
	const queryClient = useQueryClient()

	const useMutationResult = useMutation<unknown, unknown, CreateCompanyChallengeDto>(
		(createDto) => createCompanyChallenge(createDto),
		{
			async onSuccess() {
				await queryClient.invalidateQueries({ queryKey: invalidateQueryKey })
			},
		},
	)

	return useMutationResult
}
